import { useEffect, useState } from 'react';

const TrustPilotWidget = () => {
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    useEffect(() => {
        const loadScript = () => {
            if (document.querySelector('script[src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]')) {
                setIsScriptLoaded(true); // Se lo script è già presente, segna come caricato
                return;
            }

            const script = document.createElement('script');
            script.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
            script.async = true;
            script.onload = () => {
                setIsScriptLoaded(true);
                if (window.Trustpilot) {
                    window.Trustpilot.loadFromElement(document.querySelector('.trustpilot-widget'), true);
                }
            };
            document.body.appendChild(script);
        };

        loadScript();
    }, []);

    useEffect(() => {
        if (isScriptLoaded && window.Trustpilot) {
            window.Trustpilot.loadFromElement(document.querySelector('.trustpilot-widget'), true);
        }
    }, [isScriptLoaded]);

    if (!isScriptLoaded) return null;

    return (
        /* TrustBox widget - Review Collector */
        <div className="trustpilot-widget" 
            data-locale="en-US" 
            data-template-id="56278e9abfbbba0bdcd568bc" 
            data-businessunit-id="5ab19e7f7e2f2d0001ad4f7d" 
            data-style-height="52px" 
            data-style-width="100%">
            <a href="https://www.trustpilot.com/review/glasses.com" target="_blank" rel="noopener">Trustpilot</a>
        </div>
        /* End TrustBox widget */
    );
};

export default TrustPilotWidget;
